import { createContext, useContext } from 'react'
import type {
  FieldContextProviderProps,
  FieldContextValue
} from './FieldContext.types'

const FieldContext = createContext<FieldContextValue | null>(null)

export const useFieldContext = (): FieldContextValue => {
  const value = useContext(FieldContext)
  if (!value) {
    throw new Error('useFieldContext must be used within FieldContext.Provider')
  }
  return value
}

export const FieldContextProvider = ({
  value,
  children
}: FieldContextProviderProps) => {
  return <FieldContext.Provider value={value}>{children}</FieldContext.Provider>
}
